import initialState from '../initialstate';
import * as actions from '../../actions/actiontypes';

export default function helixProjectFilterMetadataReducer(state = initialState.helixProjectFilterMetadata, action) {
	switch (action.type) {
		case actions.GET_PROJECT_FILTERMETADATA_BY_PROJECTID_FROM_HELIX:
			let newState = {...state};
			if (action.error) {
				newState.result = false;
				if (action.error?.response?.data?.error?.code) {
					newState.errorCode = action.error.response.data.error.code;
				}
			} else {
				newState.result = action.response;
				let metadataBusinessUnit = [];
				action.response?.analyzers[0]?.filter?.bu?.forEach((element) => {
					if (element.hasOwnProperty('Business unit')) metadataBusinessUnit.push(element['Business unit']);
				});
				return {
					...newState,
					businessUnit: metadataBusinessUnit
				};
			}
			return newState;
		default:
			return state;
	}
}
